module.exports = __webpack_public_path__ + "static/f11_3-a8ad75d5758c425d449b3e54e743fd24.jpeg";